import type { TFilterCategory } from "@/components";
import {
	RiCalendarEventLine,
	RiLightbulbFlashLine,
	RiPagesLine,
	RiTerminalBoxLine,
} from "@remixicon/react";

export const filterCategories: TFilterCategory[] = [
	{
		id: "driver",
		icon: RiTerminalBoxLine,
		label: "Device Drivers",
		nrResults: 0,
	},
	{
		id: "event",
		icon: RiCalendarEventLine,
		label: "Events",
		nrResults: 0,
	},
	{
		id: "solution-center",
		icon: RiLightbulbFlashLine,
		label: "Software Solutions",
		nrResults: 0,
	},
	{
		id: "custom-page",
		icon: RiPagesLine,
		label: "Other",
		nrResults: 0,
	},
];

export const hitsPerPage = 1000;
